import { SimpleChanges } from '@angular/core';

export interface EditableComponent {
  canEdit: boolean;
  ngOnChanges(changes: SimpleChanges): void;
}

export function isEditableComponent(
  object: unknown
): object is EditableComponent {
  // Call hasOwnProperty function via call function because we don’t know whether the object argument is object type or not.
  return Object.prototype.hasOwnProperty.call(object, 'isAppOnline');
}
